import CloseIcon from 'components/ReusableComponents/CloseIcon'
import BulbIcon from 'components/ReusableComponents/Icons/BulbIcon'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useInternalAdmin } from 'hooks'
import moment from 'moment/moment'
import { useEffect, useState } from 'react'
import analysisApi from 'services/api/subsidiaryAnalysis'

const Diagnose = () => {
  const [isVisible, setIsVisible] = useState(false)
  const isInternalAdmin = useInternalAdmin()

  if (!isInternalAdmin) {
    return null
  }

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={{
          display: 'flex',
          gap: 10,
          alignItems: 'center',
          marginTop: 20,
          fontWeight: 500
        }}
      >
        <BulbIcon /> Diagnose
      </button>
    )
  }

  return (
    <div
      style={{
        background: '#ffffff',
        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.11)',
        borderRadius: 4,
        padding: 30,
        paddingTop: 5,
        position: 'relative'
      }}
    >
      <button
        onClick={() => setIsVisible(false)}
        style={{ position: 'absolute', top: 10, right: 10 }}
      >
        <CloseIcon />
      </button>
      <MessageLimitationAnalysis />
      <div style={{ display: 'flex', gap: 100 }}>
        <SubscribersEligibleAnalysis />
        <SubscribersAnalysis />
      </div>
      <ConversionAnalysis />
      <OutreachAnalysis />
      <DeliveryAnalysis />
    </div>
  )
}

const MessageLimitationAnalysis = () => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    analysisApi
      .messageLimitation()
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 40 }}>
        <div>
          <h2 style={{ marginBottom: 10, fontSize: 16 }}>Daily messages</h2>
          <div style={{ display: 'flex', gap: 20 }}>
            {data.daily.map((item, index) => (
              <div key={index} style={{ fontSize: 13 }}>
                <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
                  {moment(item.date).format('MMM DD')}
                </div>
                <div>Max: {item.maxLimit}</div>
                <div>Sent: {item.sent}</div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h2 style={{ marginBottom: 10, fontSize: 16 }}>Monthly messages</h2>
          <div style={{ display: 'flex', gap: 20 }}>
            <div style={{ fontSize: 13 }}>
              <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
                {moment(data.monthly.startDate).format('MMM DD')} -{' '}
                {moment(data.monthly.endDate).format('MMM DD')}
              </div>
              <div>Max: {data.monthly.maxLimit}</div>
              <div>Sent: {data.monthly.sent}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ConversionAnalysis = () => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    analysisApi
      .conversions()
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  return (
    <div style={{ display: 'flex', gap: 40 }}>
      <div>
        <h2 style={{ marginBottom: 14, fontSize: 16 }}>Booking stats</h2>
        {Object.keys(data.bookingAnalytics).map((key, index) => (
          <div
            key={index}
            style={{
              fontSize: 13,
              display: 'flex',
              width: 320,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>{key}</div>
            <div>{data.bookingAnalytics[key]}</div>
          </div>
        ))}
      </div>
      <div>
        <h2 style={{ marginBottom: 14, fontSize: 16 }}>Conversion bases</h2>
        {data.conversionBasedOnAnalytics.map((item, index) => (
          <div
            key={index}
            style={{
              fontSize: 13,
              display: 'flex',
              width: 200,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              {item.kind}
            </div>
            <div>{item.numberOfConversion}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

const OutreachAnalysis = () => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    analysisApi
      .outreach()
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  return (
    <div>
      <h2 style={{ marginBottom: 14, fontSize: 16 }}>Outreach stats</h2>

      <div style={{ display: 'flex', gap: 40 }}>
        <div>
          {Object.keys(data).map((key, index) => (
            <div
              key={index}
              style={{
                fontSize: 13,
                display: 'flex',
                width: 350,
                justifyContent: 'space-between'
              }}
            >
              <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>{key}</div>
              <div>{data[key].toString()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const DeliveryAnalysis = () => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    analysisApi
      .deliveries()
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  // "numberOfDelivered": 78,
  // "numberOfDeliveryFailed": 2,
  // "numberOfCancelled": 18,
  // "numberOfSpam": 0,
  // "deliveredRatio": 3.9,
  // "spamRatio": 0,

  return (
    <div>
      <div style={{ display: 'flex', gap: 40 }}>
        <div>
          <h2 style={{ marginBottom: 14, fontSize: 16 }}>Undelivered response</h2>
          {data.deliveryAnalytics.unDeliveredResponses.map((item, index) => (
            <div
              key={index}
              style={{
                fontSize: 13,
                display: 'flex',
                width: 350,
                justifyContent: 'space-between'
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  opacity: 0.6,
                  marginBottom: 4,
                  maxWidth: 300,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
                title={item.response}
              >
                {item.response || '-'}
              </div>
              <div>{item.count}</div>
            </div>
          ))}
        </div>
        <div>
          <h2 style={{ marginBottom: 14, fontSize: 16 }}>Delivery stats</h2>
          <div
            style={{
              fontSize: 13,
              display: 'flex',
              width: 350,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              numberOfDelivered
            </div>
            <div>{data.deliveryAnalytics.numberOfDelivered}</div>
          </div>
          <div
            style={{
              fontSize: 13,
              display: 'flex',
              width: 350,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              numberOfDeliveryFailed
            </div>
            <div>{data.deliveryAnalytics.numberOfDeliveryFailed}</div>
          </div>
          <div
            style={{
              fontSize: 13,
              display: 'flex',
              width: 350,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              numberOfCancelled
            </div>
            <div>{data.deliveryAnalytics.numberOfCancelled}</div>
          </div>
          <div
            style={{
              fontSize: 13,
              display: 'flex',
              width: 350,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              numberOfSpam
            </div>
            <div>{data.deliveryAnalytics.numberOfSpam}</div>
          </div>
          <div
            style={{
              fontSize: 13,
              display: 'flex',
              width: 350,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              deliveredRatio
            </div>
            <div>{data.deliveryAnalytics.deliveredRatio}</div>
          </div>
          <div
            style={{
              fontSize: 13,
              display: 'flex',
              width: 350,
              justifyContent: 'space-between'
            }}
          >
            <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
              spamRatio
            </div>
            <div>{data.deliveryAnalytics.spamRatio}</div>
          </div>
        </div>
      </div>
      <div>
        <h2 style={{ marginBottom: 14, fontSize: 16 }}>Campaign analytics</h2>
        <div style={{ display: 'flex', gap: 50, flexWrap: 'wrap' }}>
          {data.campaignAnalytics.map((item, index) => (
            <div
              key={index}
              style={{
                fontSize: 13,
                display: 'flex',
                flexDirection: 'column',
                width: 150,
                justifyContent: 'space-between'
              }}
            >
              <div style={{ fontWeight: 500, opacity: 0.6, marginBottom: 4 }}>
                {item.category}
              </div>
              <div>Delivered: {item.delivered}</div>
              <div>DeliveryFailed: {item.deliveryFailed}</div>
              <div>Cancelled: {item.deliveryCancelled}</div>
              <div>Pending: {item.pending}</div>
              <div>Clicks: {item.clicks}</div>
              <div>Conversions: {item.conversions}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const SubscriberInfo = ({ label, value, shouldBeHighlighted }) => (
  <div
    style={{
      fontSize: 13,
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between'
    }}
  >
    <div
      style={{
        fontWeight: 500,
        opacity: shouldBeHighlighted ? 1 : 0.6,
        marginBottom: 4,
        marginRight: 'auto'
      }}
    >
      {label}
    </div>
    <div style={{ fontWeight: shouldBeHighlighted ? 500 : 400 }}>{value}</div>
  </div>
)

const SubscriberDetails = ({ data }) => (
  <div>
    <div style={{ display: 'flex', gap: 40, width: 300 }}>
      <div style={{ width: 300 }}>
        <h2 style={{ marginBottom: 14, fontSize: 16 }}>Ineligible Subscribers</h2>

        <SubscriberInfo
          label="Ineligible Total:"
          value={data.subscriberNotEligibleTotal}
        />
        <div style={{ paddingLeft: 20 }}>
          <SubscriberInfo
            label="Ineligible due to do not call:"
            value={data.subscribersIneligibleDueToDoNotCall}
          />
          <SubscriberInfo
            label="Only cancelled bookings:"
            value={data.subscribersIneligibleDueToOnlyCancelledBookings}
          />
          <SubscriberInfo
            label="18 month+ old bookings:"
            value={data.subscribersIneligibleDueToOldBookings}
          />
          <SubscriberInfo
            label="Invited within last 3 months:"
            value={data.subscribersIneligibleDueToAlreadySentInviteIn3Months}
          />
          <SubscriberInfo
            label="Has booking in the future:"
            value={data.subscribersIneligibleDueToNextCheckout}
          />
          <SubscriberInfo
            label="Recently considered not eligible:"
            value={data.subscribersIneligibleDueToNotAnalysed}
          />
          <SubscriberInfo
            label="Repeat in year count:"
            value={data.subscribersIneligibleDueToRepeatInYearCount}
          />
          <SubscriberInfo
            label="Short link identity:"
            value={data.subscribersIneligibleDueToShortLinkIdentity}
          />
          <SubscriberInfo
            label="Incomplete data:"
            value={data.subscribersIneligibleDueToInCompletedData}
          />
          <SubscriberInfo
            label="Invalid phone:"
            value={data.subscribersIneligibleDueToInValidPhone}
          />
          <SubscriberInfo
            label="Blocked number:"
            value={data.subscribersIneligibleDueToBlockedNumber}
          />
        </div>
      </div>
    </div>
  </div>
)

const SubscribersAnalysis = () => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    analysisApi
      .subscribers()
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  return (
    <div>
      <SubscriberDetails data={data} />
    </div>
  )
}

const EligibleSubscriberDetails = ({ data }) => (
  <div>
    <div style={{ display: 'flex', gap: 40, width: 300 }}>
      <div style={{ width: 300 }}>
        <h2 style={{ marginBottom: 14, fontSize: 16 }}>Eligible Subscribers</h2>
        <SubscriberInfo
          label="Total Subscribers with Phone:"
          value={data.totalSubscribersWithPhone}
        />
        <SubscriberInfo
          label="Subscribers with Reachable Phones:"
          value={data.subscribersWithReachablePhonesCount}
        />
        <SubscriberInfo
          label="Subscribers After Business Filter:"
          value={data.subscribersAfterBusinessFilterCount}
        />
        <SubscriberInfo
          label="Subscribers After Campaign Filter:"
          value={data.subscribersAfterCampaignFilterCount}
        />
        <SubscriberInfo
          label="Subscribers After Exclusion Filter:"
          value={data.subscribersAfterExclusionFilterCount}
        />
        <SubscriberInfo
          label="Subscribers After Is Ota Only Filter:"
          value={data.subscribersAfterIsOtaOnlyFilterCount}
        />
        <SubscriberInfo
          label="Subscribers After Is Member Only Filter:"
          value={data.subscribersAfterIsMemberOnlyFilterCount}
        />
        <SubscriberInfo
          label="Target AI probability:"
          value={data.subscribersAfterProbabilityFilterCount}
        />
        <SubscriberInfo
          label="Eligible Subscribers Count:"
          value={data.eligibleSubscribersCount}
          shouldBeHighlighted
        />
        <br />
        <div
          style={{
            fontWeight: 500,
            marginBottom: 6,
            marginTop: 10,
            fontSize: 14
          }}
        >
          Subscribers Breakdown:
        </div>
        <div style={{ paddingLeft: 20 }}>
          <SubscriberInfo
            label="Subscribers With Phone:"
            value={data.subscribersBreakdown.subscribersWithPhone}
          />
          <SubscriberInfo
            label="Subscribers With Email:"
            value={data.subscribersBreakdown.subscribersWithEmail}
          />
          <SubscriberInfo
            label="Subscribers With Phone And Email:"
            value={data.subscribersBreakdown.subscribersWithPhoneAndEmail}
          />
          <SubscriberInfo
            label="Subscribers With Phone Only:"
            value={data.subscribersBreakdown.subscribersWithPhoneOnly}
          />
          <SubscriberInfo
            label="Subscribers With Email Only:"
            value={data.subscribersBreakdown.subscribersWithEmailOnly}
          />
          <SubscriberInfo
            label="Subscribers With No Contact Info:"
            value={data.subscribersBreakdown.subscribersWithNoContactInfo}
          />
        </div>
        {/* Campaign Breakdown Section */}
        <div
          style={{
            fontWeight: 500,
            marginBottom: 6,
            marginTop: 10,
            fontSize: 14
          }}
        >
          Campaign Breakdown:
        </div>
        <div style={{ paddingLeft: 20 }}>
          {Array.isArray(data.campaignBreakdown) && data.campaignBreakdown.length > 0 ? (
            data.campaignBreakdown.map((item, idx) => (
              <SubscriberInfo
                key={item.campaign || idx}
                label={item.campaign}
                value={item.count}
              />
            ))
          ) : (
            <div style={{ fontSize: 13, opacity: 0.7 }}>No data found</div>
          )}
        </div>
      </div>
    </div>
  </div>
)

const SubscribersEligibleAnalysis = () => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    analysisApi
      .eligibleSubscribers()
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  return (
    <div>
      <EligibleSubscriberDetails data={data} />
    </div>
  )
}

export default Diagnose
